import { Carousel } from '@mantine/carousel'
import { Box, Card, em, Flex, Image, Text, TextInput } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconArrowLeft, IconArrowRight, IconSearch } from '@tabler/icons-react'
import Autoplay from 'embla-carousel-autoplay'
import { ReactNode, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import Footer from '../../../components/Footer.tsx'
import CategorySkeleton from '../../../components/skeletons/CategorySkeleton.tsx'
import SliderSkeleton from '../../../components/skeletons/SliderSkeleton.tsx'
import {
	HomeSlide,
	TopCagtory,
} from '../../../interfaces/buyer/product/IProductResponse.ts'
import './home.css'

type HomeProps = {
	children: ReactNode
	slider?: HomeSlide[]
	topCategories?: TopCagtory[]
	loading: boolean
}
const Home = ({ children, slider, topCategories, loading }: HomeProps) => {
	const isMobile = useMediaQuery(`(max-width: ${em(768)})`)
	const autoplay = useRef(Autoplay({ delay: 3000 }))
	const navigate = useNavigate()

	return (
		<>
			<Flex
				direction='column'
				justify='space-between'
				w={'100%'}
				style={{
					overflow: 'hidden',
				}}
			>
				<Flex
					w={isMobile ? '100%' : '70%'}
					justify='center'
					visibleFrom='lg'
					mt='md'
					pos={'relative'}
					mx={'auto'}
				>
					{/* <Carousel
						nextControlIcon={
							<IconArrowRight
								style={{
									width: rem(25),
									height: rem(25),
									background: '#F0F1F5',

									borderRadius: '100px',
								}}
							/>
						}
						previousControlIcon={
							<IconArrowLeft
								style={{
									width: rem(25),
									height: rem(25),
									background: '#F0F1F5',

									borderRadius: '100px',
								}}
							/>
						}
						slideSize={70}
						loop
						align='start'
						slidesToScroll={3}
						slideGap='sm'
						px={isMobile ? 55 : 80}
						mb='xl'
					>
						{loading
							? [0, 1, 2, 3, 4, 5, 6, 7]?.map((_, index) => (
									<Carousel.Slide key={index}>
										<CategorySkeleton />
									</Carousel.Slide>
							  ))
							: topCategories?.map((category, index) => {
									return (
										<Carousel.Slide key={index}>
											<Flex
												h={isMobile ? '40%' : '90px'}
												w={isMobile ? 70 : 120}
												my='sm'
												align='center'
												justify='space-between'
												pos='relative'
												direction='column'
												style={{ cursor: 'pointer' }}
												onClick={() => {
													const params = encodeURIComponent(category.name)
													navigate(`/category?category=${params}`)
												}}
											>
												<Box
													style={{ zIndex: 2 }}
													p='sm'
													w={isMobile ? 60 : 80}
												>
													<Image
														loading={'eager'}
														right={15}
														h={isMobile ? 50 : 55}
														src={category.image}
													/>
												</Box>
												<Card
													radius='md'
													component='a'
													style={{ zIndex: 1 }}
													opacity={0.3}
													top={isMobile ? -10 : -5}
													bg='#62BE12'
													pos='absolute'
													h={isMobile ? 50 : 60}
													w={isMobile ? 50 : 70}
												></Card>

												<Text ta='center' size='sm' fw={isMobile ? 500 : 600}>
													{category.name}
												</Text>
											</Flex>
										</Carousel.Slide>
									)
							  })}
					</Carousel> */}
					<Swiper
						modules={[Navigation]}
						spaceBetween={isMobile ? 10 : 20}
						slidesPerView={isMobile ? 3 : 6}
						navigation={{
							nextEl: '.swiper-button-next-custom',
							prevEl: '.swiper-button-prev-custom',
						}}
						loop={true}
						style={{
							padding: isMobile ? '0 55px' : '0 80px',
							marginBottom: '2rem',
							width: '100%',
						}}
					>
						{loading
							? [0, 1, 2, 3, 4, 5, 6, 7].map((_, index) => (
									<SwiperSlide key={index}>
										<CategorySkeleton />
									</SwiperSlide>
							  ))
							: topCategories?.map((category, index) => (
									<SwiperSlide key={index}>
										<Flex
											h={isMobile ? '40%' : '90px'}
											w={isMobile ? 70 : 120}
											my='sm'
											align='center'
											justify='space-between'
											pos='relative'
											direction='column'
											style={{ cursor: 'pointer' }}
											onClick={() => {
												const params = encodeURIComponent(category.name)
												navigate(`/category?category=${params}`)
											}}
										>
											<Box style={{ zIndex: 2 }} p='sm' w={isMobile ? 60 : 80}>
												<Image
													loading='eager'
													h={isMobile ? 50 : 55}
													src={category.image}
												/>
											</Box>
											<Card
												radius='md'
												component='a'
												style={{ zIndex: 1 }}
												opacity={0.3}
												top={isMobile ? -10 : -5}
												bg='#62BE12'
												pos='absolute'
												h={isMobile ? 50 : 60}
												w={isMobile ? 50 : 70}
											/>
											<Text ta='center' size='sm' fw={isMobile ? 500 : 600}>
												{category.name}
											</Text>
										</Flex>
									</SwiperSlide>
							  ))}
					</Swiper>

					{/* Custom Navigation Buttons */}
					<div className='swiper-button-prev-custom'>
						<IconArrowLeft
							style={{
								width: '25px',
								height: '25px',
								background: '#F0F1F5',
								borderRadius: '100px',
							}}
						/>
					</div>
					<div className='swiper-button-next-custom'>
						<IconArrowRight
							style={{
								width: '25px',
								height: '25px',
								background: '#F0F1F5',
								borderRadius: '100px',
							}}
						/>
					</div>
				</Flex>
				<Flex justify='center' hiddenFrom='md' my='sm' px='sm'>
					{/* <CustomMultiSelect /> */}
					<TextInput
						w={'100%'}
						radius={'lg'}
						leftSection={<IconSearch />}
						placeholder='Search Tiger it'
						onClick={() => navigate('/search_view')}
					/>
				</Flex>
				<Flex w='100%' justify='center'>
					<Carousel
						plugins={[autoplay.current]}
						onMouseEnter={autoplay.current.stop}
						onMouseLeave={autoplay.current.reset}
						withControls={false}
						slideSize={isMobile ? '100%' : 505}
						loop
						align='start'
						withIndicators
						maw={isMobile ? '100%' : '75%'}
						slideGap={'sm'}
						// classNames={{ indicator: classes.indicator }}
					>
						{loading
							? [0, 1, 2, 3, 4].map((_, index) => (
									<Carousel.Slide w={'100%'} key={index}>
										<SliderSkeleton />
									</Carousel.Slide>
							  ))
							: slider?.map((img, index) => {
									return (
										<Carousel.Slide pr='xs' key={index}>
											<Box
												h={isMobile ? 200 : 270}
												w={isMobile ? '100%' : 505}
												p='sm'
												onClick={() => navigate('/business-details')}
											>
												<Image
													loading={'eager'}
													radius='lg'
													h={isMobile ? 150 : '90%'}
													src={img.webImage}
												/>
											</Box>
										</Carousel.Slide>
									)
							  })}
					</Carousel>
				</Flex>
				<Flex justify={'center'} align='center' p={0}>
					{children}
				</Flex>
				<Footer />
			</Flex>
		</>
	)
}

export default Home
